/**
 * @name SuccessGrid
 * @description Componente para los registros con éxito de las cargas masivas
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Report } from '@components';
import { Flex, MUI, Unicons, Typography } from '@styles';

const SuccessGrid = (props) => {
  const { columns, rows } = props;

  // Colors
  const GREEN_70 = '#00AF77B3';
  // const GREEN_10 = '#00AF771A';

  return (
    <>
      <Styled.SuccessBox>
        <Unicons.CircleCheck size="28" color={GREEN_70} style={{ marginRight: '8px' }} />
        <Flex.Col>
          <Typography.Text color={GREEN_70}><Typography.Medium>{i18n.t('HttpResponse.success')}</Typography.Medium></Typography.Text>
          <Typography.Small>{i18n.t('MassiveUploads.successUpload')}</Typography.Small>
        </Flex.Col>
      </Styled.SuccessBox>
      <MUI.Box padding="16px">
        <Report
          showHeader={false}
          columns={columns}
          rows={rows}
          rowsLength={rows.length}
        />
      </MUI.Box>
    </>
  );
};

SuccessGrid.propTypes = {
  // Arreglo de columnas para el componente Report.
  columns: PropTypes.array.isRequired,
  // Arreglo de registros del JSON.
  rows: PropTypes.array
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.SuccessBox = styled(Flex.Row)`
  margin: 16px;
  padding: 16px;
  border-radius: 6px;
  border: 2px solid #00AF77B3; // Green 70%
  background-color: #00AF771A; // Green 10%
`;

export default SuccessGrid;